import { AppRegistry } from 'react-native'

import App from '@app-hero/shared/src/App'

AppRegistry.registerComponent('appHero', () => App)
AppRegistry.runApplication('appHero', {
  rootTag: document.getElementById('root'),
})
